import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile.service';
import { NgIf, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-manage-password',
    templateUrl: './manage-password.component.html',
    styleUrls: ['./manage-password.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        NgStyle,
        RouterLink,
    ],
})
export class ManagePasswordComponent implements OnInit, OnDestroy {

  @ViewChild('inputPassword')
  inputPassword: ElementRef;

  public user: any;
  public matchPwd = false;
  private subscription: ISubscription[];

  private userEmail = 'abubakar.mujawar@us.sogeti.com';

  public userForm = new UntypedFormGroup({});

  public screenWidth: number;

  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  bar4: string;
  public show = false;

  private colors = ['#F00', '#0F0', '#0F0'];

  private impermissible_prefixes = [
    'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
    'appl', 'ibm', 'pass', 'ros', 'asdf', 'sign', 'basic', 'log', 'sys', 'cadam',
    'test', 'tso', 'demo', 'net', 'valid', 'new', 'vtam', 'focus', 'xxx', 'game',
    '1234', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', 'bmw', 'mai', 'dez',
    'mae', 'okt', 'cad', 'catia', 'bm1ramf', 'beit08a', 'am07cu4', '19mond6'
  ];
  APP_SETTINGS: any;

  constructor(private fb: UntypedFormBuilder, private userProfileService: UserProfileService, private utilityService: UtilityService) {
    this.screenWidth = this.utilityService.getScreenWidth();
   }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.subscription = [];
    this.userForm = this.fb.group({
      oldPassword: new UntypedFormControl('', Validators.required),
      newPassword: new UntypedFormControl('', Validators.required),
      confirmPassword: new UntypedFormControl('', Validators.required)
    });
  }


  private measureStrength(p) {
    let force = 0;
    const regex = /(\#|\$)/g;

    const lowerLetters = /[a-z]+/.test(p);
    const numbers = p.match(/[0-9]/g) ? p.match(/[0-9]/g).length < 5 : false;
    const symbols = regex.test(p);

    const flags = [lowerLetters, numbers, symbols];

    let passedMatches = 0;
    for (let flag of flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
    force += passedMatches * 10;

    // penality (short password)
    force = (p.length <= 7) ? Math.min(force, 10) : force;

    // penalty for impermissible prefixes
    force = this.impermissible_prefixes.find(prefix => p.substr(0, prefix.length).includes(prefix)) ? Math.min(force, 10) : force;

    // penality (poor variety of characters)
    force = (passedMatches <= 2) ? Math.min(force, 10) : force;

    return force;

  }
  private getColor(s) {
    let idx = 0;
    if (s <= 10) {
      idx = 0;
    } else {
      idx = 2;
    }
    return {
      idx: idx + 1,
      col: this.colors[idx]
    };
  }

  checkPasswordStrength() {
    const password = this.userForm.controls.newPassword.value;
    this.setBarColors(3, '#DDD');
    if (password) {
      const c = this.getColor(this.measureStrength(password));
      this.setBarColors(c.idx, c.col);
      return c.idx;
    }
  }
  private setBarColors(count, col) {
    for (let _n = 0; _n < count; _n++) {
      this['bar' + _n] = col;
    }
  }

  togglePasswordDisplay() {
    this.show = !this.show;
    if (this.show) {
      this.inputPassword.nativeElement.type = 'text';
    } else {
      this.inputPassword.nativeElement.type = 'password';
    }
  }

  verifyPassword() {
    if (this.userForm.controls.newPassword.value === this.userForm.controls.confirmPassword.value) {
      this.matchPwd = true;
    } else {
      this.matchPwd = false;
    }
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    if (valid) {
      const pwdObj = {"email": this.userEmail, "oldPassword": value.oldPassword, "newPassword": value.newPassword};
      this.subscription.push(this.userProfileService.changePassword(pwdObj).subscribe(data => {
      }));
    }
  }
  ngOnDestroy(): void {
    this.subscription.map(s => s.unsubscribe());
  }

}
